// Release theme: keep product URL updated with ?variant=ID
document.addEventListener("DOMContentLoaded", () => {
  const productForms = document.querySelectorAll("form[action*='/cart/add']");

  productForms.forEach((form) => {
    form.addEventListener("change", () => {
      // Dropdown variant picker
      const variantSelect = form.querySelector("select[name='id']");
      if (variantSelect && variantSelect.value) {
        const newUrl = `${window.location.pathname}?variant=${variantSelect.value}`;
        window.history.replaceState(null, null, newUrl);
        return;
      }

      // Swatch / radio button variant picker
      const checkedInput = form.querySelector("input[name='id'][type='radio']:checked");
      if (checkedInput) {
        const newUrl = `${window.location.pathname}?variant=${checkedInput.value}`;
        window.history.replaceState(null, null, newUrl);
      }
    });
  });
});